/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [slideout-provider-hook.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 25.11.19, 14:20
 */
import Slideout from '../../vendor/slideout/slideout';
// import '../../vendor/slideout/slideout.css';
// import '../../vendor/slideout/slideout.css';
import SlideoutNavigation from "./slideout-navigation";

import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";

export const SlideoutContext = React.createContext();

// use in the top of the component hiecharchy to reach the whole window app
const SlideoutProvider = ({children}) => {
    const [isShowNavigation, setIsShowNavigation] = useState(false);
    const slideOut = useRef(null);
    const {username} = useParams();
    const location = useLocation();

    useEffect(() => {
        const menu = document.getElementById('slide-menu-id');
        const panel = document.getElementById('slide-panel-id');

        slideOut.current = new Slideout({
            panel: panel,
            menu: menu,
            padding: 256,
            tolerance: 70,
            side: 'left',
            touch: false
        });

        slideOut.current.on('open', () => {
            setIsShowNavigation(true);
        });

        slideOut.current.on('close', () => {
            setIsShowNavigation(false);
        });
    }, []);

    return (
        <SlideoutContext.Provider value={{
            isOpen: slideOut.current && slideOut.current.isOpen(),
            toggle: () => slideOut.current.toggle(),
            open: () => slideOut.current.open(),
            close: () => slideOut.current.close()
        }}>
            <div id="slide-menu-id">
                {isShowNavigation && <SlideoutNavigation username={username} location={location}/>}
            </div>
            <div id="slide-panel-id" className='container-fluid slideout-panel-container'>
                {children}
            </div>
        </SlideoutContext.Provider>
    )
};

export default SlideoutProvider;